import { BookingContext } from './types'

export function getInitialContext(): BookingContext {
  return {
    firstEmailChange: true,
    requestParams: {
      slug: '',
      party: {
        adults: 2,
        childAges: [],
      },
      pitchtypeId: '',
      chargetypeId: undefined,
      stayRange: {
        start: new Date().toISOString(),
        end: new Date().toISOString(),
      },
      selectedExtras: {},
    },
    selectedExtras: {},
    isAuthenticated: false,
    loggedInUserEmail: '',
    user: undefined,
    email: '',
    lastInterestEmail: '',
    submitErrors: {},
    loadingErrors: [],
    contactDetails: {
      address: {
        city: '',
        country: '',
        postCode: '',
        street: '',
      },
      email: '',
      firstName: '',
      lastName: '',
      phone: {
        countryDialingCode: '',
        number: '',
        countryDialingNumber: '',
      },
      sendTextMessage: false,
      password: '',
    },
    otherDetails: {
      carRegistration: '',
      partyNames: '',
      groupName: '',
      specialRequests: '',
      estimatedTimeOfArrival: '',
    },
    retries_remain: 5,
    langCode: '',
  }
}
